export default __webpack_public_path__ + "static/media/91_desktop.ee52cb84.jpg";